<template>
  <UIInput
    id="facbookPixelId"
    :value="store.facebook.fbPixelId"
    :placeholder="t('common.placeholderFacebookPixelIdInput')"
    @update-value="updateFacbookPixelId"
    @blur="store.addToHistory()"
  />
  <p class="mt-2 text-sm font-normal text-gray-600">
    <strong>{{ t('common.facebookPixelFunnelLabel') }}</strong>
    {{ t('common.facebookPixelFunnelText') }}
  </p>
  <p class="mt-2 text-sm font-normal text-gray-600">
    <strong>{{ t('common.facebookPixelEmbedLabel') }}</strong>
    {{ t('common.facebookPixelEmbedText') }}
  </p>
  <div class="mt-2 flex items-start gap-2 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-600">
    <InfoCircleIcon class="mt-0.5 h-4 w-4 shrink-0 text-gray-400" />
    <span>
      {{ t('common.facebookPixelConsentCallout') }}
      <strong class="text-primary-600">{{ t('common.facebookPixelConsentCalloutLink') }}</strong>.
    </span>
  </div>
</template>

<script setup lang="ts">
import { useAppStore } from "@/store/app";
import { UIInput } from "@gohighlevel/ghl-ui";
import { InfoCircleIcon } from "@gohighlevel/ghl-icons/24/outline";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const store = useAppStore();

const updateFacbookPixelId = (value: string) => {
  store.facebook.fbPixelId = value;
  store.anyUnsavedChanges = true;
};
</script>
